import axios from "axios";
import { fpoStatesUrl, fpoDistrictsUrl } from "../constants/apis";
import { getAuthToken } from "../helpers/local_storage_helpers";

const authHeaders = () => ({
    headers: { Authorization: `Token ${getAuthToken()}` },
});

/**
 * GET /fpo/states/ — all states.
 */
export const getFPOStates = async () => {
    const response = await axios.get(fpoStatesUrl, authHeaders());
    return response;
};

/**
 * GET /fpo/districts/?state=<id-or-name> — districts for the given state
 * (accepts either a state UUID or its name, case-insensitive).
 */
export const getFPODistricts = async (state) => {
    const response = await axios.get(fpoDistrictsUrl, {
        ...authHeaders(),
        params: { state },
    });
    return response;
};
